import { useState, useEffect } from 'react';
import api from '../../../../data/api';
import tagApi from '@/api/tagApi';

const useVideoData = ({ categoryId, userData, userInfo, data }) => {
	const [responseData, setResponseData] = useState([]);
	const [totvideos, setTotVideos] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const [startIndex, setStartIndex] = useState(0);
	const [selectedTags, setSelectedTags] = useState([]);
	const [selectedDurations, setSelectedDurations] = useState([]);
	const [selectedLevels, setselectedLevels] = useState([]);
	const [selectedInstructors, setSelectedInstructors] = useState([]);
	const [instructors, setInstructors] = useState([]);
	const [tags, setTags] = useState([]);
	const [sortby, setSortBy] = useState('');
	const [products, setProducts] = useState([{ name: '', id: '', subname: '' }]);
	const [selectedProducts, setSelectedProducts] = useState([]);
	const [savedVideoIds, setSavedVideoIds] = useState([]);
	const itemsPerPage = 15;

	// Format products from Shopify data
	useEffect(() => {
		if (data?.products) {
			const formattedProducts = data.products.map(product => ({
				name: product?.title,
				id: product?.id,
				subname: product?.metafieldValue || ''
			}));
			setProducts(formattedProducts);
		}
	}, [data]);

	// Fetch tags
	useEffect(() => {
		tagApi.getActiveTags()
			.then(filteredTags => { setTags(filteredTags) })
			.catch(error => {
				console.error('Error fetching tags:', error);
			});
	}, []);

	// Data fetching function
	const fetchData = async (selectedTags, selectedDurations, selectedLevels, selectedInstructors, selectedProducts) => {
		try {
			const userId = userInfo && userInfo?.userId ? userInfo?.userId : '';
			const endIndex = startIndex + itemsPerPage - 1;
			const selectedTagsIds = selectedTags?.map(tag => tag).join(',');
			const durations = selectedDurations?.map(duration => duration).join(',');
			const levels = selectedLevels?.map(level => level).join(',');
			// const instructorList = selectedInstructors?.join(',');
			// const productList = selectedProducts?.join(',');

			const response = await api.getSingleFilteredVideos({
				startIndex,
				endIndex,
				selectedTags: selectedTagsIds,
				selectedDurations: durations,
				selectedLevels: levels,
				sortby: sortby || 'latest',
				selectedInstructors: selectedInstructors,
				selectedProducts: selectedProducts,
				userId,
				categoryId
			});

			setTotVideos(Math.ceil(response?.data?.libraryVideosData[0]?.totalRecords / itemsPerPage));
			setResponseData(response?.data?.libraryVideosData);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// Wrapper function for fetching videos with filters
	const fetchVideosByTags = async (
		selectedTags,
		selectedDurations,
		selectedLevels,
		selectedInstructors,
		selectedProducts
	) => {
		try {
			fetchData(selectedTags, selectedDurations, selectedLevels, selectedInstructors, selectedProducts);
		} catch (error) {
			console.error('Error fetching filtered videos:', error);
		}
	};

	return {
		responseData,
		setResponseData,
		totvideos,
		currentPage,
		startIndex,
		setCurrentPage,
		setStartIndex,
		selectedTags,
		setSelectedTags,
		selectedDurations,
		setSelectedDurations,
		selectedLevels,
		setselectedLevels,
		selectedInstructors,
		setSelectedInstructors,
		instructors,
		setInstructors,
		tags,
		sortby,
		setSortBy,
		products,
		setProducts,
		selectedProducts,
		setSelectedProducts,
		fetchData,
		fetchVideosByTags,
		savedVideoIds,
		setSavedVideoIds
	};
};

export default useVideoData;
